import { isNumber } from 'lodash';

import type { Distance } from 'models';

import { generateDistancePrice, generateDistanceExtremePrice } from './generateDistancePrice';

/**
 * @description
 * Fetch current distance price
 */
function fetchPrice(
  distance: Distance | nil,
  isPushPayment?: boolean,
  isConfirmation?: boolean,
  transferPrice?: number | null,
  changeDistancePaidPrice?: number | null,
) {
  if (!distance) {
    return;
  }

  if (isPushPayment) {
    return generateDistanceExtremePrice(distance);
  }

  if (isConfirmation) {
    return 0;
  }

  if (isNumber(transferPrice)) {
    return transferPrice;
  }

  const price = generateDistancePrice(distance);

  if (isNumber(changeDistancePaidPrice) && isNumber(price)) {
    return Math.max(0, price - changeDistancePaidPrice);
  }

  return price;
}

export { fetchPrice };
